module.exports = __webpack_public_path__ + "static/img/bg-ar.247a5ffe.png";